import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer';
import Newsletter from '../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faCalendarAlt,
  faArrowRight,
  faUser,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { getBlogs, getBlogImageUrl } from '../services/blogService';

export default function Blogs() {
  const [blogs, setBlogs]       = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);
  const [page, setPage]         = useState(1);
  const [meta, setMeta]         = useState(null);

  const fetchBlogs = async (pageNum = 1) => {
    setLoading(true);
    setError(null);
    try {
      const res = await getBlogs(pageNum);
      // Support both paginated { data, meta } and plain array responses
      if (Array.isArray(res)) {
        setBlogs(res);
        setMeta(null);
      } else {
        setBlogs(res.data ?? []);
        setMeta(res.meta ?? res.links ?? null);
      }
    } catch (err) {
      setError(err.message || 'Failed to load blogs.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs(page);
  }, [page]);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  return (
    <>
      <Header />

      <section className="breadcrumbsection">
        <div className='container'>
          <h1>Blogs</h1>
          <ul className='breadcrumblinks'>
            <li><Link to="/">Home</Link></li>
            <li><FontAwesomeIcon icon={faChevronRight} /></li>
            <li>Blogs</li>
          </ul>
        </div>
      </section>

      {/* Blogs Section */}
      <section className="blogs-main-section">
        <div className="container">
          <div className="blogs-section-header text-center mb-5">
            <h2 className="blogs-section-title">Latest Articles & Insights</h2>
            <div className="blogs-title-underline"></div>
            <p className="blogs-section-subtitle">
              Stay updated with the latest trends, tips, and insights from the world of embroidery digitizing
            </p>
          </div>

          {/* Loading State */}
          {loading && (
            <div className="blogs-loading">
              <FontAwesomeIcon icon={faSpinner} spin className="blogs-spinner" />
              <p>Loading articles...</p>
            </div>
          )}

          {/* Error State */}
          {!loading && error && (
            <div className="blogs-error">
              <p>{error}</p>
              <button className="btn btn-primary mt-3" onClick={() => fetchBlogs(page)}>
                Try Again
              </button>
            </div>
          )}

          {/* Empty State */}
          {!loading && !error && blogs.length === 0 && (
            <div className="blogs-empty">
              <p>No articles found. Check back soon!</p>
            </div>
          )}

          {/* Blog Grid */}
          {!loading && !error && blogs.length > 0 && (
            <>
              <div className="blogs-grid">
                {blogs.map((blog) => (
                  <div key={blog.id} className="blog-card">
                    <div className="blog-image-wrapper">
                      <img
                        src={getBlogImageUrl(blog.image)}
                        alt={blog.title}
                        className="blog-image"
                        onError={(e) => { e.target.src = '/images/service1.png'; }}
                      />
                      <div className="blog-image-overlay"></div>
                    </div>

                    <div className="blog-content">
                      <div className="blog-meta">
                        <div className="blog-meta-item">
                          <FontAwesomeIcon icon={faCalendarAlt} />
                          <span>{formatDate(blog.blog_date)}</span>
                        </div>
                        <div className="blog-meta-item">
                          <FontAwesomeIcon icon={faUser} />
                          <span>{blog.author}</span>
                        </div>
                      </div>

                      <h3 className="blog-title">{blog.title}</h3>

                      <p className="blog-description">
                        {blog.excerpt || (blog.content ? blog.content.replace(/<[^>]+>/g, '').substring(0, 160) + '...' : '')}
                      </p>

                      <Link to={`/blogs/${blog.slug}`} className="blog-view-btn">
                        View Details
                        <FontAwesomeIcon icon={faArrowRight} className="btn-arrow" />
                      </Link>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              {meta && meta.last_page > 1 && (
                <div className="blogs-pagination">
                  <button
                    className="blogs-page-btn"
                    disabled={page === 1}
                    onClick={() => setPage(p => p - 1)}
                  >
                    &larr; Previous
                  </button>

                  <div className="blogs-page-numbers">
                    {Array.from({ length: meta.last_page }, (_, i) => i + 1).map(num => (
                      <button
                        key={num}
                        className={`blogs-page-num ${num === page ? 'active' : ''}`}
                        onClick={() => setPage(num)}
                      >
                        {num}
                      </button>
                    ))}
                  </div>

                  <button
                    className="blogs-page-btn"
                    disabled={page === meta.last_page}
                    onClick={() => setPage(p => p + 1)}
                  >
                    Next &rarr;
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </section>

      <Newsletter />
      <Footer />
    </>
  );
}